module.exports = __webpack_public_path__ + "img/hamburguer.d43f1d1c.svg";